// NOTE Layout
// Todas las paginas van dentro de este Layout
// Las paginas son incluidas en el layout usando props.children


// React 
import React from 'react'

// Componentes
import './Layout.css'
import BarraNav from './BarraNav'
import PiePagina from './PiePagina'

const Layout = (props) => {
	return (

		// Use .container-fluid for a full width container, spanning the entire width of the viewport.
		<div className="container-fluid">
			<BarraNav/>
				{props.children}
			<PiePagina/>
		</div>
	)
}


export default Layout


// WEBPACK FOOTER //
// ./src/layout/Layout.js